import { Dtos, SuretyAccountId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../utils/request";
import { accountMetadataQueryKey } from "./account.keys";

export const useFetchAccountMetadata = (accountId: SuretyAccountId) => {
	const { get } = useRequest();

	const { data, error, isLoading, refetch } = useQuery({
		queryKey: accountMetadataQueryKey(accountId),
		queryFn: async () =>
			await get<Dtos.SuretyAccount.Metadata.Get.Response>(
				`/v2/surety/accounts/${accountId}/metadata`,
			),
	});

	return {
		metadata: data,
		metadataError: error,
		metadataIsLoading: isLoading,
		refetchAccountMetadata: refetch,
	};
};
